module.exports = __webpack_public_path__ + "static/media/course.aef05313.jpg";